import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: OrderingWindowPadding | null = null,
  action: ActionType<typeof config>,
): OrderingWindowPadding | null {
  switch (action.type) {
    case getType(config.setOrderingWindowPadding): {
      const { value } = action.payload;
      return value || null;
    }
    default:
      return state;
  }
}
